/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespDealerDetails_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ContactDealerInlineForm_user" | "PdpSharedSellerTabsVariant_user" | "PdpSharedCallDealerCta_user" | "PdpSharedDealerDetailsHeader_user" | "PdpRespSellerItemTileCarousel_user">;
    readonly " $refType": "PdpRespDealerDetails_user";
};
export type PdpRespDealerDetails_user$data = PdpRespDealerDetails_user;
export type PdpRespDealerDetails_user$key = {
    readonly " $data"?: PdpRespDealerDetails_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '5accae86aa28d40d2e180a07bba2dd26';
export default node;
